import { createHOC } from 'vue-hoc';
import withUser from '~lib/common/hoc/withUser';

import auth, { authResultKey } from '~lib/common/providers/auth';
import userManagement from '~lib/common/providers/userManagement';

import LoginAsTool from './LoginAsTool';
import parseGroupMetadata from '../../../utils/parseGroupMetadata';

const options = {
  name: 'LoginAsToolContainer',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      state: {
        loading: false,
        loggingIn: false,
        orgs: [],
        orgMembers: [],
        error: null,
      },
    };
  },
  async created() {
    if (!(await auth.isAuthenticated())) {
      this.$router.replace({ name: 'login' });
      return;
    }
    this.fetchOrgs();
  },
  methods: {
    async fetchOrgs() {
      try {
        this.state.loading = true;
        let orgs = (await userManagement.get('/extension/groups')).data.groups
          .map((group) => ({
            ...group,
            metadata: parseGroupMetadata(group),
          }))
          .filter((group) => !group.metadata.parent);
        this.state.orgs = orgs;
      } catch (e) {
        this.state.error = e;
      } finally {
        this.state.loading = false;
      }
    },
  },
};

const renderWith = {
  props: {
    loading() {
      return this.state.loading;
    },
    loggingIn() {
      return this.state.loggingIn;
    },
    orgs() {
      return this.state.orgs;
    },
    orgMembers() {
      return this.state.orgMembers;
    },
    error() {
      return this.state.error;
    },
  },
  listeners: {
    async fetchOrgMembers(org) {
      try {
        this.state.loading = true;
        this.state.error = null;
        this.state.orgMembers = await userManagement.getOrgMembers(org._id);
      } catch (e) {
        this.state.error = e;
      } finally {
        this.state.loading = false;
      }
    },
    async loginAs(org, user) {
      try {
        this.state.loggingIn = true;
        this.state.error = null;
        const response = await userManagement.post('/auth/loginAs', {
          orgId: org._id,
          email: user.email,
        });
        const authResult = response.data;
        authResult.fromSkeletonKey = true;
        await auth.persistAuthResult(authResult);
        window.location.replace('/auth/account/profile');
      } catch (e) {
        this.state.error = e;
      } finally {
        this.state.loggingIn = false;
      }
    },
  },
};

const LoginAsToolContainer = createHOC(LoginAsTool, options, renderWith);
export default withUser()(LoginAsToolContainer);
